import { useState, useEffect } from "react";

import TEXT from "../../../config/text";
import REQUESTS from "../../../api/requests";
import classes from "../style/packageList.module.scss";
import ErrorMessage from "../../../components/ErrorMessage";

import { Button, Form, Input, Checkbox, Drawer } from "antd";

import { SafetyCertificateOutlined } from "@ant-design/icons";

const StausListDrawer = ({
  onClose,
  visible,
  current,
  getData,
  translation,
  followAddElement,
}) => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState({
    type: false,
    text: "",
  });

  const onValuesChange = (e) => {
    setMessage({
      type: false,
      text: "",
    });
  };

  useEffect(() => {
    if (visible === false) {
      setLoading(false);
      onValuesChange();
    }
  }, [visible]);

  const onFinish = (values) => {
    setLoading(true);

    const body = {
      name: values.name,
      earning: Number(values.earning),
      switch_amount: Number(values.switch_amount),
    };

    function callback() {
      if (!current) {
        followAddElement.setCurrentPage(1);
        followAddElement.setSearch("");
        followAddElement.setSort(["id", "DESC"]);
        followAddElement.setCurrentPage(1);
        followAddElement.setLimit(10);
        followAddElement.setTotal();
      }
      setLoading(false);
      onClose();
      getData();
    }

    function errorCallback(err) {
      setLoading(false);
      setMessage({ type: false, text: err });
    }

    if (current) {
      body.id = Number(current.id);
      REQUESTS.STATUS.EDIT(body, callback, errorCallback);
    } else {
      REQUESTS.STATUS.ADD(body, callback, errorCallback);
    }
  };

  useEffect(() => {
    if (current) {
      form.setFields([
        {
          name: "name",
          value: current.name,
        },

        {
          name: "earning",
          value: current.earning,
        },

        {
          name: "switch_amount",
          value: current.switch_amount,
        },
      ]);
    } else {
      form.resetFields();
    }
  }, [current, visible]);

  return (
    <Drawer
      title={
        current
          ? `${translation["Edit"] || TEXT["Edit"]} 
            ${translation["Status"] || TEXT["Status"]}`
          : `${translation["Add"] || TEXT["Add"]}
             ${translation["Status"] || TEXT["Status"]}`
      }
      placement="right"
      onClose={onClose}
      visible={visible}
    >
      <Form
        form={form}
        name="profile"
        layout="vertical"
        onFinish={onFinish}
        onValuesChange={onValuesChange}
      >
        <Form.Item
          label={translation["Name"] || TEXT["Name"]}
          name="name"
          rules={[
            {
              required: true,
              message: "Please input your name ",
            },
          ]}
        >
          <Input />
        </Form.Item>

        <Form.Item
          label={translation["Earning"] || TEXT["Earning"]}
          name="earning"
          rules={[
            {
              required: true,
              message: "Please input  earning",
            },
          ]}
        >
          <Input type={"number"} min={0} />
        </Form.Item>

        <Form.Item
          label={translation["Switch amount"] || TEXT["Switch amount"]}
          name="switch_amount"
          rules={[
            {
              required: true,
              message: "Please input Switch Amount",
            },
          ]}
        >
          <Input type={"number"} min={0} />
        </Form.Item>

        <ErrorMessage message={message} />
        <div className={classes["save_button_div"]}>
          <Form.Item>
            <Button
              type="primary"
              htmlType="submit"
              className={classes["save_button"]}
              loading={loading}
            >
              {translation["Save"] || TEXT["Save"]}
            </Button>
          </Form.Item>
        </div>
      </Form>
    </Drawer>
  );
};

export default StausListDrawer;
